export const LogoMark = ({ className = "h-7 w-7", inverted = false }) => (
  <svg viewBox="0 0 32 32" className={className} aria-hidden="true" focusable="false">
    <rect width="32" height="32" fill={inverted ? "#F6F5F1" : "#171717"} />
    <path
      fill={inverted ? "#171717" : "#F6F5F1"}
      d="M6 8h9v3H9v3.5h5v3H9V21h6v3H6zM17 8h2a8 8 0 0 1 0 16h-2z"
    />
  </svg>
);
